import Documents from '../../../banking/components/spaces/documents/Documents';

const DocumentsScreen = () => {
    return <Documents />;
};

export default DocumentsScreen;
